module.exports = __webpack_public_path__ + "static/RobotoMono-Regular-5b216bd740a21288742dcaec4ac61556.woff";